export const DSPREFIX = 'FS.ds.'

function isQuotaExceededError(err) {
  return (
    err instanceof DOMException &&
    // everything except Firefox
    (err.code === 22 ||
      // Firefox
      err.code === 1014 ||
      // test name field too, because code might not be present
      // everything except Firefox
      err.name === 'QuotaExceededError' ||
      // Firefox
      err.name === 'NS_ERROR_DOM_QUOTA_REACHED')
  )
}

export const getSessionStorageItem = (cacheableKey) => {
  let sessionValue
  const dsKey = `${DSPREFIX}${cacheableKey}`
  try {
    sessionValue = JSON.parse(sessionStorage.getItem(dsKey))
  } catch (e) {
    sessionValue = sessionStorage.getItem(dsKey)
  }

  return sessionValue
}

export const setSessionStorageItem = (cacheableData) => {
  Object.keys(cacheableData).forEach((key) => {
    const sessionValue = JSON.stringify(cacheableData[key])
    try {
      // quota can be exceeded over 5mb
      sessionStorage.setItem(`${DSPREFIX}${key}`, sessionValue)
    } catch (err) {
      if (isQuotaExceededError(err)) {
        // eslint-disable-next-line no-console
        console.warn('sessionStorage has reach the quota limit')
      }
    }
  })
}

export const removeSessionStorageItem = (key) => {
  sessionStorage.removeItem(`${DSPREFIX}${key}`)
}
